<template>
  <v-data-table
    mobile-breakpoint="0"
    item-key="id"
    :options.sync="studentTableOptions"
    :server-items-length="totalItems"
    :headers="headers"
    :items-per-page="5"
    :items="students"
    @input="$emit('update:selected', $event)"
    :footer-props="footerTable"
    v-bind="this.$attrs"
    loading-text="Đang Tải"
    :loading="load"
  >
    <template v-slot:no-data>
      <div class="my-14 font-weight-bold">
        <div>Hiện tại chưa có giáo viên trong danh sách.</div>
        <div>Vui lòng thực hiện thao tác thêm giáo viên ở phía trên.</div>
      </div>
    </template>

    <template v-slot:[`header.name`]="{ header }">
      <span class="pl-2">
        {{ header.text }}
      </span>
    </template>
    <template v-slot:[`item.stt`]="{ index }">
      <span>{{ number + index + 1 }}</span>
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <CardTeacherName :teacher="item" link isCodeShown />
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip small class="white--text" v-if="item.status" :color="item.status | statusColor" label>
        <span class="white--text">{{ item.status | teacherStatus }}</span>
      </v-chip>
    </template>
    <template v-slot:[`item.gender`]="{ item }">{{ item.gender | gender }}</template>
    <template v-slot:[`item.dob`]="{ item }">
      <span>{{ item.dob | ddmmyyyy }}</span>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <TeacherTableActions :id="item.groupStudentId" />
    </template>
  </v-data-table>
</template>
<script>
import CardTeacherName from '@/components/basic/card/CardTeacherName.vue'
import TeacherTableActions from './TeacherTableActions.vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import { getHeader } from './utils'

export default {
  data() {
    return {
      studentTableOptions: {},
      selected: [],
      status: null,
      statuses: [
        { text: 'Active', value: 'false' },
        { text: 'Blocked', value: 'true' }
      ],
      number: 0,
      load: true
    }
  },
  props: {
    filter: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    CardTeacherName,
    TeacherTableActions
  },
  computed: {
    headers() {
      return getHeader(this.groupInfo.category)
    },
    ...mapState('salaryGroupTeacher', ['totalItems', 'students', 'pageText', 'loading', 'studentSearchParams']),
    ...mapGetters('salaryGroup', ['groupInfo']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số giáo viên mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  methods: {
    ...mapActions('salaryGroupTeacher', ['requestPageSettings'])
  },
  filters: {
    getCurrentClass(currentClass) {
      return currentClass == null ? '' : currentClass.title
    }
  },
  watch: {
    studentTableOptions: {
      handler(newOptions, oldOptions) {
        if (this.groupInfo.category) {
          const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
          const pageChanged = newOptions.page !== oldOptions.page
          if (pageChanged || itemPerPageChanged) {
            this.requestPageSettings({
              page: newOptions.page,
              itemsPerPage: newOptions.itemsPerPage,
              defaultId: this.groupInfo.defaultId,
              defaultType: this.groupInfo.defaultType,
              id: this.groupInfo.id
            })
          }
        }
      },
      deep: true
    },
    groupInfo() {
      this.requestPageSettings({
        page: this.studentTableOptions.page,
        itemsPerPage: this.studentTableOptions.itemsPerPage,
        defaultId: this.groupInfo.defaultId,
        defaultType: this.groupInfo.defaultType,
        id: this.groupInfo.id
      })
    },
    students() {
      this.number = (this.studentTableOptions.page - 1) * this.studentTableOptions.itemsPerPage
    },
    loading() {
      this.load = this.loading
    }
  }
}
</script>
